import {create} from "zustand";
import {TemplateModel} from "../models/TemplateModel";
import {UserModel} from "../models/UserModel";

interface AppState {
    templates: TemplateModel[];
    userModel: UserModel | null;
    isIntegration: boolean;
}

export const useAppStore = create<AppState>(() => ({
    templates: [],
    userModel: null,
    isIntegration: false,
}));
